import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@ndd/ui";
import { Info } from "lucide-react";
import type { MetricEnvelope } from "../../../../../shared/metrics";
import { ILLUSTRATIVE_NOTE, popoverFacts } from "../../../lib/metrics-display";

export function MetricDefinitionPopover({
  label,
  envelope,
}: {
  label: string;
  envelope: MetricEnvelope;
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={`Definition of ${label}`}
          className="inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-subtle hover:text-foreground"
        >
          <Info className="h-[14px] w-[14px]" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 text-sm">
        <p className="font-semibold text-foreground">{label}</p>
        <p className="mt-1 text-muted-strong">{envelope.definition}</p>
        {envelope.sentence && (
          <p className="mt-2 text-muted-strong">{envelope.sentence}</p>
        )}
        <dl className="mt-3 grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 text-body">
          {popoverFacts(envelope).map((fact) => (
            <React.Fragment key={`${fact.term}:${fact.detail}`}>
              <dt className="text-muted-foreground">{fact.term}</dt>
              <dd>{fact.detail}</dd>
            </React.Fragment>
          ))}
        </dl>
        {envelope.source === "fake" && (
          <p className="mt-3 text-xs text-muted-foreground">{ILLUSTRATIVE_NOTE}</p>
        )}
      </PopoverContent>
    </Popover>
  );
}
